import { StarOutlined } from "@ant-design/icons";
import { GarageIcon } from "shared-components/Components/CustomIcons/GarageIcon/web";
import { GrillIcon } from "shared-components/Components/CustomIcons/GrillIcon/web";
import { TVIcon } from "shared-components/Components/CustomIcons/TVIcon/web";
import { GardenIcon } from "shared-components/Components/CustomIcons/GardenIcon/web";
import { YardIcon } from "shared-components/Components/CustomIcons/YardIcon/web";
import { GymIcon } from "shared-components/Components/CustomIcons/GymIcon/web";
import { BalconyIcon } from "shared-components/Components/CustomIcons/BalconyIcon/web";
import { PoolIcon } from "shared-components/Components/CustomIcons/PoolIcon/web";
import { ACIcon } from "shared-components/Components/CustomIcons/ACICon/web";
import { HeatingIcon } from "shared-components/Components/CustomIcons/HeatingIcon/web";
import { WifiIcon } from "shared-components/Components/CustomIcons/WifiIcon/web";
import { PlacardBedroomIcon } from "shared-components/Components/CustomIcons/PlacardBedroomIcon/web";
import { TerraceIcon } from "shared-components/Components/CustomIcons/TerraceIcon/web";
import { DepositIcon } from "shared-components/Components/CustomIcons/DepositIcon/web";
import { WoodStoveIcon } from "shared-components/Components/CustomIcons/WoodStoveIcon/web";
import { WhiteLineIcon } from "shared-components/Components/CustomIcons/WhiteLineIcon/web";
import { DressingRoomIcon } from "shared-components/Components/CustomIcons/DressingRoomIcon/web";
import { PlayroomIcon } from "shared-components/Components/CustomIcons/PlayroomIcon/web";
import { HotWaterIcon } from "shared-components/Components/CustomIcons/HotWaterIcon/web";
import { FurnitureIcon } from "shared-components/Components/CustomIcons/FurnitureIcon/web";
import { CalefonIcon } from "shared-components/Components/CustomIcons/CalefonIcon/web";
import { BoxIcon } from "shared-components/Components/CustomIcons/BoxIcon/web";
import { ServiceRoomIcon } from "shared-components/Components/CustomIcons/ServiceRoomIcon/web";
import { JacuzziIcon } from "shared-components/Components/CustomIcons/JacuzziIcon/web";
import { LosaRadianteIcon } from "shared-components/Components/CustomIcons/LosaRadianteIcon/web";
import { PlacardKitchenIcon } from "shared-components/Components/CustomIcons/PlacardKitchenIcon/web";
import { TerraceLaundryIcon } from "shared-components/Components/CustomIcons/TerraceLaundryIcon/web";
import { BungalowIcon } from "shared-components/Components/CustomIcons/BungalowIcon/web";
import { LaundryIcon } from "shared-components/Components/CustomIcons/LaundryIcon/web";
import { PipedGasIcon } from "shared-components/Components/CustomIcons/PipedGasIcon/web";
import { AltilloIcon } from "shared-components/Components/CustomIcons/AltilloIcon/web";
import { SaunaIcon } from "shared-components/Components/CustomIcons/SaunaIcon/web";
import { WalkinClosetIcon } from "shared-components/Components/CustomIcons/WalkinClosetIcon/web";
import { LivingDinningIcon } from "shared-components/Components/CustomIcons/LivingDinningIcon/web";
import { PorcelainFloorIcon } from "shared-components/Components/CustomIcons/PorcelainFloorIcon/web";
import { DogIcon } from "shared-components/Components/CustomIcons/DogIcon/web";
import { ElevatorIcon } from "shared-components/Components/CustomIcons/ElevatorIcon/web";
import { CommonUseRoomIcon } from "shared-components/Components/CustomIcons/CommonUseRoomIcon/web";
import { SpaIcon } from "shared-components/Components/CustomIcons/SpaIcon/web";
import { BasementIcon } from "shared-components/Components/CustomIcons/BasementIcon/web";
import { LaundryRoomIcon } from "shared-components/Components/CustomIcons/LaundryRoomIcon/web";
import { SolariumIcon } from "shared-components/Components/CustomIcons/SolariumIcon/web";
import { PeopleIcon } from "shared-components/Components/CustomIcons/PeopleIcon/web";

export const IconFacility = ({ id }) => {

    switch (id.toString()) {
        case "1": //Balcón
            return <BalconyIcon />
            break;

        case "2": //Box
            return <BoxIcon />
            break;

        case "3": //Calefacción Individual
        case "33": //Calefacción Central
        case "45": //Calefacción
            return <HeatingIcon />
            break;

        case "4": //Calefón
            return <CalefonIcon />
            break;

        case "5": //Cochera
        case "9": //Garaje
        case "51": //Garaje
            return <GarageIcon />
            break;
        
        case "6": //Depósito
            return <DepositIcon />
            break;

        case "7": //Dormitorio de servicio
            return <ServiceRoomIcon />
            break;

        case "8": //Estufa a Leña
            return <WoodStoveIcon />
            break;
        
        case "10": //Jacuzzi
            return <JacuzziIcon />
            break;

        case "11": //Línea Blanca
            return <WhiteLineIcon />
            break;
        
        case "12": //Losa Radiante
            return <LosaRadianteIcon />
            break;
        
        case "13": //Parrillero
        case "21": //Barbacoa
            return <GrillIcon />
            break;

        case "14": //Placard en cocina
            return <PlacardKitchenIcon />
            break;

        case "15": //Placard en dormitorio
            return <PlacardBedroomIcon />
            break;

        case "16": //Terraza
            return <TerraceIcon />
            break;

        case "17": //Terraza Lavadero
            return <TerraceLaundryIcon />
            break;
        
        case "18": //Vestidor
            return <DressingRoomIcon />
            break;
        
        case "20": //Ascensor
            return <ElevatorIcon />
            break;
        
        case "22": //Bungalow
            return <BungalowIcon />
            break;
        
        case "23": //GYM
            return <GymIcon />
            break;

        case "25": //Lavandería
            return <LaundryRoomIcon />
            break;
        
        case "74": //Lavadero
            return <LaundryIcon />
            break;
        
        case "27": //Piscina
            return <PoolIcon />
            break;

        case "28": //Playroom
            return <PlayroomIcon />
            break;

        case "29": //Salón de uso común
            return <CommonUseRoomIcon />
            break;
        
        case "30": //Spa
            return <SpaIcon />
            break;
        
        case "31": //WiFi
            return <WifiIcon />
            break;

        case "32": //Agua Caliente Central
            return <HotWaterIcon />
            break;
        
        case "34": //Instalación de TV cable
            return <TVIcon />
            break;
        
        case "35": //Previsión A.A.
        case "36": //Aire Acondicionado
            return <ACIcon />
            break;
        
        case "37": //Gas por Cañería
            return <PipedGasIcon />
            break;

        case "40": //Altillo
            return <AltilloIcon />
            break;

        case "65": //Sótano
            return <BasementIcon />
            break;

        case "69": //Amueblada
            return <FurnitureIcon />
            break;

        case "70": //Jardín
            return <GardenIcon />
            break;
        
        case "72": //Patio
            return <YardIcon />
            break;

        case "76": //Sauna
            return <SaunaIcon />
            break;

        case "78": //Solárium
            return <SolariumIcon />
            break;
        
        case "216": //Walk-in Closet
            return <WalkinClosetIcon />
            break;
        
        case "218": //Living comedor
            return <LivingDinningIcon/>
            break;

        case "220": //Piso porcelanato
            return <PorcelainFloorIcon />
            break;

        case "222": //Se aceptan mascotas
            return <DogIcon />
            break;

        case "225": //Se aceptan grupos de jóvenes
            return <PeopleIcon />
            break;

        default:
            return <StarOutlined />
            break;
    }
}